import { ApiBaseService, ApiV2Service } from './api.base.service';

export class AdminService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async decodeString(encodedString: string, password: string): Promise<{result: string}> {
    return this.api.post(`admin/decodeString`, { encodedString, password });
  }

}

export default new AdminService();
